import { query, where } from 'firebase/firestore';
import { IRoutePolicy } from '../sp-types';
import { getItems, saveItem } from './genericFB';

const COLLECTION_NAME = 'route-policies';

export async function getRoutePolicies(accountId: string): Promise<IRoutePolicy[] | undefined> {
  return await getItems<IRoutePolicy>(accountId, COLLECTION_NAME);
}

export async function getRoutePoliciesByMaterial(
  accountId: string,
  materialId: string,
): Promise<IRoutePolicy[] | undefined> {
  return await getItems<IRoutePolicy>(accountId, COLLECTION_NAME, (q) =>
    query(q, where('materialId', '==', materialId)),
  );
}

export async function createRoutePolicy(routePolicy: IRoutePolicy): Promise<IRoutePolicy | null> {
  return await saveItem<IRoutePolicy>(`${routePolicy.accountId}__${routePolicy.routeId}`, routePolicy, COLLECTION_NAME);
}
